import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { IBackendCart } from '@rbi-ctg/menu';
import Currency from 'components/currency';

import { Divider, Total, TotalLabel, TotalsRow } from './modal-order-details.styled';

export const OrderPricesDetails = ({ cart }: { cart: IBackendCart }) => {
  const { formatMessage } = useIntl();
  const { subTotalCents, discounts, donations, taxCents } = cart;

  const discountsAmount = useMemo(() => {
    return discounts?.reduce((acc, { value }) => acc + value, 0) || 0;
  }, [discounts]);

  const donationsAmount = useMemo(() => {
    return donations?.reduce((acc, { totalCents }) => acc + totalCents, 0) || 0;
  }, [donations]);

  return (
    <>
      {/* Subtotal */}
      <TotalsRow>
        <TotalLabel>{formatMessage({ id: 'subtotal' })}</TotalLabel>
        <Total>
          <Currency amount={subTotalCents} />
        </Total>
      </TotalsRow>

      {/* Savings */}
      {discountsAmount > 0 && (
        <TotalsRow>
          <TotalLabel>{formatMessage({ id: 'comboOfferSavings' })}</TotalLabel>
          <Total>
            <Currency amount={discountsAmount} />
          </Total>
        </TotalsRow>
      )}

      {/* Donation */}
      {donationsAmount > 0 && (
        <TotalsRow>
          <TotalLabel>{formatMessage({ id: 'donation' })}</TotalLabel>
          <Total>
            <Currency amount={donationsAmount} />
          </Total>
        </TotalsRow>
      )}

      {/* Taxes */}
      <TotalsRow>
        <TotalLabel>{formatMessage({ id: 'taxes' })}</TotalLabel>
        <Total>
          <Currency amount={taxCents} />
        </Total>
      </TotalsRow>

      <Divider />
    </>
  );
};
